<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span>Đặt lịch khám</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="3"></b-col>
          <b-col md="6">
            <el-steps :active="2" align-center finish-status="success">
              <el-step
                title="Bước 1"
                description="Thông tin người đăng ký khám"
              ></el-step>
              <el-step
                title="Bước 2"
                description="Chọn cơ sở khám chữa bệnh"
              ></el-step>
              <el-step title="Bước 3" description="Chọn ngày khám"></el-step>
              <el-step
                title="Bước 4"
                description="Chọn đối tượng khám"
              ></el-step>
              <el-step
                title="Bước 5"
                description="Xác nhận hoàn thành"
              ></el-step>
            </el-steps>
          </b-col>
          <b-col md="3"></b-col>
        </b-row>
      </div>

      <div
        class="card"
        style="margin: 40px; border-radius: 20px; border-color: #eee"
      >
        <h5 style="text-align: center; margin-top: 30px">Chọn ngày khám</h5>
        <i style="text-align: center; margin-top: 30px">Kích để chọn</i>
        <div
          class="card-body"
          style="padding-left: 12%; padding-top: 0px; padding-right: 12%"
        >
          <el-calendar v-model="currentDate">
            <template slot="dateCell" slot-scope="{ date, data }">
              <div
                class="box-date"
                :class="processDate(date, data)"
                @click="chooseDate(date, data)"
              >
                <p>
                  {{ formatDate(date) }}
                </p>
              </div>
            </template>
          </el-calendar>

          <div class="text-center mt-3">
            <el-button @click="goBack()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
            <el-button @click="handleBtnNext()" type="info" plain>{{
              "Tiếp tục"
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DangKyKhamModel from "./DangKyKhamModel";
import * as moment from "moment";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      register_date: null,
      currentDate: null,
      passDate: true,
      mData: {
        viewMode: "create",
        moduleName: "DangKyKham",
        dataDefault: {},

        dataForm: MethodService.copyObject(DangKyKhamModel.dataForm),
        validForm: DangKyKhamModel.validForm,
      },
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    initForm() {
      let DataAll = sessionStorage.getItem("steps");
      DataAll = DataAll ? JSON.parse(DataAll) : false;
      if (DataAll) {
        this.passDate = false;
        this.register_date = DataAll.register_date
          ? moment(DataAll.register_date, "YYYYMMDD").format("DD/MM/YYYY")
          : moment().add(1, "days").format("DD/MM/YYYY");
        this.currentDate = DataAll.register_date
          ? new Date(moment(DataAll.register_date))
          : new Date(moment().add(1, "days"));
      } else {
        this.register_date = moment().add(1, "days").format("DD/MM/YYYY");
        this.currentDate = new Date(moment().add(1, "days"));
      }
    },
    storeForm() {
      let DataAll = sessionStorage.getItem("steps");
      DataAll = DataAll ? JSON.parse(DataAll) : false;
      if (DataAll) {
        sessionStorage.removeItem("steps");
        DataAll.register_date = moment(this.register_date, "DD/MM/YYYY").format(
          "YYYYMMDD"
        );
        sessionStorage.setItem("steps", JSON.stringify(DataAll));
      } else {
        this.$router.push({ name: "Admin-DangKyKham-create" });
      }
    },

    handleBtnNext() {
      this.storeForm();
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-createStep4",
      });
    },

    processDate(date, data) {
      let DataAll = JSON.parse(sessionStorage.getItem("steps"));
      let offdays = DataAll.offdays;
      let day = new Date(date);
      let dayNow = new Date();
      let dayMax = new Date(moment().add(3, "months"));
      if (
        day.getTime() <= dayNow.getTime() ||
        day.getTime() > dayMax.getTime()
      ) {
        return "inactive";
      } else if (offdays && offdays.includes(new Date(day).getDay())) {
        return "inactive";
      } else if (moment(day).format("DD/MM/YYYY") == this.register_date) {
        return "is-selected";
      }
      return "";
    },

    chooseDate(date, data) {
      let key = this.processDate(date, data);
      if (key) {
        return;
      }
      this.register_date = moment(date).format("DD/MM/YYYY");
    },

    formatDate(date) {
      return new Date(date).getDate();
    },
  },
  mounted: function () {
    let DataAll = sessionStorage.getItem("steps");
    this.initForm();
  },
};
</script>

<style lang="scss" scoped>
.box-date {
  flex: 1;
  padding: 8px;
}
.box-date:hover {
  background-color: #f2f8fe;
}

.box-date.is-selected {
  color: #ffffff;
  background: #63c2de !important;
}
.box-date.is-selected :hover {
  color: #ffffff;
  background: #63c2de !important;
}
.inactive {
  color: #c0c4cc;
  cursor: not-allowed;
}
.inactive:hover {
  background-color: #ffffff;
}
.el-calendar-day {
  padding: 0 !important;
  display: flex;
}
.el-calendar-day:hover {
  background-color: unset !important;
}
td.is-selected {
  background: unset !important;
}

@media screen and (max-width: 600px) {
  .card {
    margin: 5px !important;
  }
  .card-body {
    padding: 10px!important;
  }
  ::v-deep.el-calendar {
    .el-calendar__header {
      flex-direction: column !important;
    }
    .el-calendar__body {
      padding: 12px 5px 32px !important;
    }
    .el-calendar-table {
      .el-calendar-day {
        height: unset!important;
        padding: 0px!important;
      }
    }
  }
}
</style>